var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 11.75C5.78125 11.75 5.48708 11.6277 5.2425 11.3831C4.9975 11.1381 4.875 10.8438 4.875 10.5V3C4.875 2.65625 4.9975 2.36187 5.2425 2.11687C5.48708 1.87229 5.78125 1.75 6.125 1.75H11.75C12.0938 1.75 12.3881 1.87229 12.6331 2.11687C12.8777 2.36187 13 2.65625 13 3V10.5C13 10.8438 12.8777 11.1381 12.6331 11.3831C12.3881 11.6277 12.0938 11.75 11.75 11.75H6.125ZM3.625 14.25C3.28125 14.25 2.98687 14.1277 2.74187 13.8831C2.49729 13.6381 2.375 13.3438 2.375 13V4.875C2.375 4.69792 2.435 4.54938 2.555 4.42938C2.67458 4.30979 2.82292 4.25 3 4.25C3.17708 4.25 3.32562 4.30979 3.44562 4.42938C3.56521 4.54938 3.625 4.69792 3.625 4.875V13H9.875C10.0521 13 10.2006 13.06 10.3206 13.18C10.4402 13.2996 10.5 13.4479 10.5 13.625C10.5 13.8021 10.4402 13.9504 10.3206 14.07C10.2006 14.19 10.0521 14.25 9.875 14.25H3.625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.e8da542211b07c8f075ab2114b4e9d1d.svg";
export { ForwardRef as ReactComponent };